import { memo } from "react";
import type { BookedTeleconsultoriaRow } from "../types";
import { ActivitySectionFrame } from "./ActivitySectionFrame";
import { BookedTeleconsultoriaRowCard } from "./BookedTeleconsultoriaRowCard";

/**
 * Teleconsultorias marcadas da PRESTADORA (visão clínica): consultas nas agendas
 * e convites aceitos, já filtrados por período e profissional.
 * A clínica só acompanha: quem inicia é o teleconsultor, na visão profissional.
 * (A visão profissional usa "Próximas teleconsultorias".)
 */
export const BookedTeleconsultoriasSection = memo(function BookedTeleconsultoriasSection({
  rows,
  isLoading,
  hasError,
  onRefresh,
}: {
  rows: BookedTeleconsultoriaRow[];
  isLoading: boolean;
  hasError: boolean;
  onRefresh: () => void;
}) {
  return (
    <ActivitySectionFrame
      title="Teleconsultorias marcadas"
      subtitle="Consultas dos seus profissionais no período."
      isLoading={isLoading}
      hasError={hasError}
      errorText="Não foi possível carregar as teleconsultorias marcadas."
      isEmpty={!rows.length}
      emptyText="Nenhuma teleconsultoria marcada neste período."
      onRefresh={onRefresh}
    >
      {rows.map((row) => (
        <BookedTeleconsultoriaRowCard key={row.appointmentId} row={row} showTeleconsultor />
      ))}
    </ActivitySectionFrame>
  );
});
